(function ($) {
  $(document).ready(function () {
    var body = $("body");
    body.find("footer").prepend('<button class="btn back-to-top" aria-label="Scroll to the top of the page"></button>');
    var contBack = body.find(".back-to-top");
    $(window).scroll(function () {
      if ($(window).scrollTop() > 1000) {
        contBack.addClass("active");
        contBack.removeClass("inactive");
      } else {
        contBack.addClass("inactive");
        contBack.removeClass("active");
      }
    });
    contBack.on("click", function () {
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        500
      );
      body.removeClass("scroll-overflow-hidden");
    });
  });
})(jQuery);
